<template>
    <div class="form-group">
        <FormLabel required>資格を知られたきっかけは？</FormLabel>
        <div class="flex-1 col-span-8">
            <FormInput :value="value" @input="s => $emit('input', s)"
                       type="select" :options="triggerList" class="lg:w-500p"/>
            <ErrorText name="trigger" :errors="errors"/>
        </div>
    </div>
</template>

<script>
import FormInput from "../app/FormInput";
import ErrorText from "../ErrorText";
import applicationSelectItem from "../../mixins/applicationSelectItem";
import FormLabel from "./FormLabel";

export default {
    name: "TriggerForm",
    components: {FormLabel, ErrorText, FormInput},
    mixins: [applicationSelectItem],

    props: {
        value: {
            type: String
        },
        errors: {
            type: Object | Array
        }
    },
}
</script>

<style scoped>

</style>
